export const ESTADO_LABEL = {
  sin_fichar: 'Sin fichar',
  trabajando: 'Trabajando',
  en_descanso: 'En descanso',
  finalizada: 'Jornada finalizada',
};

export const ESTADO_STYLE = {
  sin_fichar: 'bg-zinc-100 text-zinc-700 border-zinc-300',
  trabajando: 'bg-green-50 text-green-700 border-green-500',
  en_descanso: 'bg-amber-50 text-amber-700 border-amber-500',
  finalizada: 'bg-red-50 text-red-700 border-red-400',
};

export const ESTADO_DOT = {
  sin_fichar: 'bg-zinc-400',
  trabajando: 'bg-green-500',
  en_descanso: 'bg-amber-500',
  finalizada: 'bg-red-500',
};

export const ACCION_CONFIG = {
  entrada: {
    label: 'Fichar Entrada',
    icon: 'LogIn',
    btn: 'bg-white border-green-500 text-green-700 hover:bg-green-50',
  },
  inicio_descanso: {
    label: 'Iniciar Descanso',
    icon: 'Coffee',
    btn: 'bg-white border-amber-500 text-amber-700 hover:bg-amber-50',
  },
  fin_descanso: {
    label: 'Volver de Descanso',
    icon: 'Undo2',
    btn: 'bg-white border-blue-500 text-blue-700 hover:bg-blue-50',
  },
  fin_jornada: {
    label: 'Fin de Jornada',
    icon: 'LogOut',
    btn: 'bg-white border-red-500 text-red-700 hover:bg-red-50',
  },
};

export const EVENTO_LABEL = {
  entrada: 'Entrada',
  inicio_descanso: 'Inicio descanso',
  fin_descanso: 'Vuelta descanso',
  fin_jornada: 'Fin de jornada',
};

export const AUSENCIA_LABEL = {
  vacaciones: 'Vacaciones',
  baja_medica: 'Baja médica',
  permiso_retribuido: 'Permiso retribuido',
  ausencia_justificada: 'Ausencia justificada',
  ausencia_injustificada: 'Ausencia injustificada',
  otro: 'Otro',
};

export const AUSENCIA_STYLE = {
  vacaciones: 'bg-sky-100 text-sky-800',
  baja_medica: 'bg-rose-100 text-rose-800',
  permiso_retribuido: 'bg-violet-100 text-violet-800',
  ausencia_justificada: 'bg-amber-100 text-amber-800',
  ausencia_injustificada: 'bg-red-100 text-red-800',
  otro: 'bg-zinc-100 text-zinc-700',
};

// Convierte horas decimales (ej. 8.75) a formato "8h 45m"
export const formatHoras = (dec, signed = false) => {
  if (dec === null || dec === undefined || isNaN(dec)) return '-';
  const neg = dec < 0;
  const abs = Math.abs(dec);
  let h = Math.floor(abs);
  let m = Math.round((abs - h) * 60);
  if (m === 60) { h += 1; m = 0; }
  const base = m === 0 ? `${h}h` : `${h}h ${String(m).padStart(2, '0')}m`;
  if (signed) return (neg ? '-' : '+') + base;
  return (neg ? '-' : '') + base;
};
